import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';


import { CSSTransition, TransitionGroup } from 'react-transition-group';

import preventDefault from '../../utils/preventDefault';

import classNames from 'classnames';

// Icons
import {FontAwesomeIcon as FA} from '@fortawesome/react-fontawesome';
import faTrashAlt from '@fortawesome/fontawesome-pro-light/faTrashAlt';
import faCheck from '@fortawesome/fontawesome-pro-regular/faCheck';
import faTimes from '@fortawesome/fontawesome-pro-light/faTimes';



const mapStateToProps = state => ({});

const matchDispatchToProps = dispatch => {
  return bindActionCreators({  }, dispatch)
};





class SwipeDownHeader extends Component {
  
  constructor (props){
    super(props)
    
    this.touchstart = this.touchstart.bind(this);
    this.touchmove = this.touchmove.bind(this);
    this.touchend = this.touchend.bind(this);
    
    this.headerRef = null;
    this.setHeaderRef = element => {
      this.headerRef = element;
    };
    
    // this.threshold = 100
    
    this.state = {
      startY: 0,
      y: 0
    }
  }
  
  touchstart (e) {
    if (e.touches.length !== 1 || !e.changedTouches)
      return
     
    const touchobj = e.changedTouches[0];
    if (!touchobj || !touchobj.pageY)
      return
    
    const { onStart } = this.props;
    this.setState({startY: touchobj.pageY, y:0})
     
    if ( onStart )
      onStart({...this.state})
  }
  
  touchmove (e) {
    if (e.touches.length !== 1 || !e.changedTouches)
      return
    
    const touchobj = e.changedTouches[0];
    if (!touchobj || !touchobj.pageY)
      return
    
    const {startY} = this.state;
    const { onUpdate } = this.props;
    
    this.setState({y: touchobj.pageY - startY})
    
    if ( onUpdate ){
      onUpdate(this.state);
    }
    e.preventDefault();
  }
  
  touchend (e) {
    const { onUpdate, onEnd } = this.props;
    this.setState({startY: 0, y: 0});
    if ( onUpdate )
      onUpdate({...this.state});
    if ( onEnd )
      onEnd({...this.state});
    // console.log("touchend")
    // e.preventDefault();
  }
  
  componentDidMount (){
    if ( !this.headerRef )
      return
    
    this.headerRef.addEventListener('touchstart', this.touchstart);
    this.headerRef.addEventListener('touchmove', this.touchmove);
    this.headerRef.addEventListener('touchend', this.touchend);
  }
  
  componentWillUnmount (){
    this.headerRef.removeEventListener('touchstart', this.touchstart);
    this.headerRef.removeEventListener('touchmove', this.touchmove);
    this.headerRef.removeEventListener('touchend', this.touchend);
  }
  
  render () {
    const { children } = this.props;
    return <div className="action-sheet-header" ref={this.setHeaderRef}>{children}</div>;
  }
}


class BioLinkActionSheet extends Component {
  
  constructor (props){
    super(props)
    this.onRemove = this.onRemove.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
    this.stopPropagation = this.stopPropagation.bind(this);
    
    this.state = {
      y: 0,
      sneakPeek: false
    }
  }
  
  onRemove(e){
    preventDefault(e);
    
    const { component } = this.props;
    const { onRemove, props } = component || {};
    const { hideActionSheet } = props || {};
    
    if (onRemove)
      onRemove();
    if (hideActionSheet)
      hideActionSheet();
  }
  
  onSuccess (e){
    preventDefault(e);
    
    const { component } = this.props;
    const { onSuccess, props } = component || {};
    const { hideActionSheet } = props || {};
    
    if (onSuccess)
      onSuccess();
    if (hideActionSheet)
      hideActionSheet();
  }
  
  componentWillReceiveProps (nextProps){
    if (nextProps.component === this.props.component)
      return
    
    const { component } = nextProps;
    const { ActionComponent } = component || {}
    
    if (!!ActionComponent)
      document.body.classList.add('action-sheet-open');
    else
      document.body.classList.remove('action-sheet-open');
  }
  
  // editBlock (e){
  //   preventDefault(e);
  //   
  //   const { index, fields, setActionSheet } = this.props;
  //   // const blockType = this.blockType()
  //   const blockType = {ActionComponent: ButtonBlockSettings, title: "Block Settings"}
  //   
  //   if (blockType)
  //     setActionSheet({...blockType, onRemove: () => fields.remove(index), props: this.props});
  // }
  
  stopPropagation(e){
    e.stopPropagation()
  }
  
  onSneakPeekUpdate (offset) {
    this.setState({y: offset.y});
  }
  onSneakPeekStart (offset) {
    this.setState({sneakPeek: true});
  }
  onSneakPeekEnd (offset) {
    this.setState({sneakPeek: false});
    // setTimeout((() => this.setState({sneakPeek: false})).bind(this), 300);
  }
  
  render() {
    const { component, values } = this.props;
    const { ActionComponent, title, cancel, onRemove, props } = component || {};
    const { hideActionSheet } = props || {};
    const { y, sneakPeek } = this.state;
    
    return (<TransitionGroup component={React.Fragment}>
      {!!ActionComponent && 
        <CSSTransition
          timeout={300}
          classNames="slidein"
          onClick={hideActionSheet}><div className={classNames({'action-sheet': true, 'sneak-peek': sneakPeek})} onClick={hideActionSheet}><div className="table-align"><div className="table-cell-bottom">
          <div className="action-sheet-body" onClick={this.stopPropagation} style={{transform: y > 0 && `translateY(${y}px)`}}>
            { !!ActionComponent ? <React.Fragment>
              <SwipeDownHeader onUpdate={this.onSneakPeekUpdate.bind(this)} onStart={this.onSneakPeekStart.bind(this)} onEnd={this.onSneakPeekEnd.bind(this)}>
                {onRemove && <span className="clickable-icon danger left" title="Remove" onClick={this.onRemove}><FA icon={faTrashAlt} /></span>}
                {<span className={classNames({"clickable-icon": true, "right": true, "success": !cancel})} title="Done" onClick={this.onSuccess}><FA icon={cancel === true? faTimes : faCheck} /></span>}
                
                { title && <div className="action-sheet-title">{title}</div> }
              </SwipeDownHeader>
              <div>
                <ActionComponent {...props} values={values} />
              </div>
            </React.Fragment> : <div />}
          </div>
        </div></div></div></CSSTransition>
      }
    </TransitionGroup>);
    
  }
  
}



export default connect(mapStateToProps, matchDispatchToProps)(BioLinkActionSheet);


// WEBPACK FOOTER //
// ./src/components/SmartPages/SmartPageActionSheet.js